// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"615b1780","492":"8a5ca2a5"}[chunkId] + ".chunk.js";
};